import { useDaily, useDailyEvent } from '@daily-co/daily-react'
import { noop } from 'lodash'

// leave the call when the remote participant leaves (this makes sure the hardware recording stops)
// TODO explore what this means in terms of another user being able to pop in and out of the call if they have a weak
// connection. this might prevent that from working
export function useLeaveOnRemotePartipantLeft() {
  const callObject = useDaily()

  // `leave()` returns a Promise — swallow its rejection. If the call is already being torn down via
  // the complete/defer path (Daily.co emits `participant-left` for the remote as we exit), Daily's
  // internal generator chain hits a null state and unhandled-rejects (`null is not an object
  // (evaluating 't.includes')`). Mirrors the pattern used in useVisitPopUpState's unmount safety net.
  useDailyEvent('participant-left', () => callObject?.leave().catch(noop))
}
